module.exports = __webpack_public_path__ + "img/googlepay.994dd190.svg";